import fp from 'lodash/fp';
import React from 'react';
import { Col, Collapse, Row } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import { compose, lifecycle, withHandlers, withProps, withStateHandlers } from 'recompose';
import { filterType } from '../../../../constants';
import { noCapMap } from '../../../../utils';
import Icon from '../../icon';

const PublisherFilter = ({
  handlePublisherFilterChange,
  filterPublishers,
  toggleFilter,
  showFilter,
  refresh
}) => (
    filterPublishers.length > 1 ?
      <div className='filter publisher-filter'>
        <Row className='button-gutter'>
          <Col xs={12}>
            <h2
              className='flexbox'
              type='button'
              onClick={toggleFilter}
              aria-expanded={showFilter}
              aria-controls='publisher-filter'>
              {
                showFilter ?
                  <Icon icon='minus-large'></Icon> :
                  <Icon icon='plus-large'></Icon>
              }
              <span id='label'>Publisher</span>
            </h2>
          </Col>
        </Row>
        <Row className='no-gutter'>
          <Collapse id="publisher-filter" in={showFilter}>
            <fieldset>
              <Typeahead
                key={refresh}
                id="publisher-name"
                labelKey="name"
                filterBy={['name']}
                onChange={handlePublisherFilterChange}
                options={fp.flow(
                  fp.sortBy(({ name }) => fp.lowerCase(name)),
                )(filterPublishers)}
                placeholder="Select publisher"
              />
            </fieldset>
          </Collapse>
        </Row>
      </div> : null
  )

export default compose(
  withStateHandlers(
    {
      showFilter: false,
      refresh: 0
    },
    {
      toggleFilter: ({ showFilter }) => () => ({
        showFilter: !showFilter
      }),
      resetFilter: ({ refresh }) => ({ business, publisher }) => ({
        refresh: (business || publisher) ? refresh : (refresh + 1)
      })
    }
  ),
  withProps(({ business, publishers }) => ({
    filterPublishers: fp.flow(
      noCapMap((publisher, index) => ({
        id: publisher.id,
        name: publisher.name,
        type: filterType.Publisher,
        index: business ? index + 1 : index
      })),
      business ? fp.concat({
        id: business.id,
        name: business.name,
        type: filterType.Business,
        index: 0
      }) : fp.identity
    )(fp.filter(
      ({ activeItemCount }) => activeItemCount > 0
    )(publishers))
  })),
  withHandlers({
    handlePublisherFilterChange: ({ filterPublishers, onChange }) => (selected) => {
      const selectedFilter = fp.find(({ index }) => index === fp.get('[0].index')(selected))(filterPublishers);

      const selectedPublisher = fp.get('type')(selectedFilter) === filterType.Publisher ? fp.get('id')(selectedFilter) : undefined;
      const selectedBusiness = fp.get('type')(selectedFilter) === filterType.Business ? fp.get('id')(selectedFilter) : undefined;

      onChange({
        publisher: selectedPublisher,
        business: selectedBusiness
      });
    }
  }),
  lifecycle({
    componentDidUpdate(prevStat) {
      const { filter, resetFilter } = this.props
      if (!fp.isEqual(filter)(prevStat.filter)) {
        resetFilter(filter)
      }
    }
  })
)(PublisherFilter)


// WEBPACK FOOTER //
// ./src/containers/components/filters/partials/publisher-filter.js